import { memo, ReactElement, useEffect, useState } from "react";
import {
    Pencil, Trash, Eye, ToggleLeft, ToggleRight,
    Save, Plus, RefreshCcw, X, ArrowUpRight,
    ArrowDownLeft, Copy, SendIcon,
    LucideIcon
} from "lucide-react";
import { Button, ButtonProps } from "./Button/Button";

export const Actions = memo(({ animateType = { animate: false }, ...props }: ActionsType): ReactElement => {

    const [isActive, setIsActive] = useState<boolean>();

    useEffect(() => {
        setIsActive(props.active)
    }, [props.active]);

    const Buttons = [
        {
            title: "cancel",
            icon: X,
            onClick: props.onCancel,
            variant: "solid" as const,
            className: "text-rose-50   bg-rose-500  hover:bg-rose-600",
        },
        {
            title: "delete",
            icon: Trash,
            onClick: props.onDelete,
            variant: "outline" as const,
            className: "text-red-600 border-red-600 hover:bg-red-50",
        },
        {
            title: "edit",
            icon: Pencil,
            onClick: props.onEdit,
            variant: "outline" as const,
            className: "text-yellow-600 border-yellow-600 hover:bg-yellow-50",
        },
        {
            title: "view",
            icon: Eye,
            onClick: props.onView,
            variant: "ghost" as const,
        },
        {
            title: "activepasive",
            icon: isActive ? ToggleRight : ToggleLeft,
            onClick: () => props.onActive?.(!isActive),
            variant: "ghost" as const,
            label: isActive ? "active" : "pasive",
            className: isActive ? "text-green-600" : "text-gray-400",
        },
        {
            title: "save",
            icon: Save,
            onClick: props.onSave,
            variant: "solid" as const, // السيف غالباً يكون Solid
        },
        {
            title: "new",
            icon: Plus,
            onClick: props.onNew,
            variant: "solid" as const,
            className: "bg-green-600 hover:bg-green-700",
        },
        {
            title: "reload",
            icon: RefreshCcw,
            onClick: props.onReload,
            variant: "outline" as const,
        },

        {
            title: "transition",
            icon: ArrowUpRight,
            onClick: props.onTransition,
            variant: "outline" as const,
        },
        {
            title: "back",
            icon: ArrowDownLeft,
            onClick: props.onBack,
            variant: "ghost" as const,
        },
        {
            title: "copy",
            icon: Copy,
            onClick: props.onCopy,
            variant: "outline" as const,
        },
        {
            title: "send",
            icon: SendIcon,
            onClick: props.onSend,
            variant: "solid" as const,
        }
    ];

    const getFormId = (form: any, btnTitle: string): string | undefined => {
        if (typeof form === "string") return form;
        if (form?.id && form?.button === btnTitle) return form.id;
        return undefined;
    };

    return (
        <div className="flex items-center gap-1 m-1">
            {Buttons.filter((btn) => (props.actions || []).includes(btn.title as any))
                .map((btn, index) => {
                    const isDisabled = btn.onClick === undefined;

                    return (
                        <Button
                            key={btn.title}
                            variant={btn.variant}
                            size="sm"
                            disabled={isDisabled}
                            onClick={btn.onClick}
                            type={props.form ? "submit" : "button"}
                            form={getFormId(props.form, btn.title)}
                            className={`${btn.className || ""} duration-300  ${props.showActionsTitle ? "px-3" : "p-2"}`}
                        >
                            <btn.icon size={16} className="transition-transform duration-200 group-hover:scale-110" />

                            {props.showActionsTitle && (
                                <span>
                                    {props.getLang?.(btn.label || btn.title) || (btn.label || btn.title)}
                                </span>
                            )}
                        </Button>
                    );
                })}
        </div>
    );
});